import React, { useEffect, useState } from "react";
import http from "../../../../services/http";

/**
 * 30/10/2026 (Quân): giấy phép gắn TÀI KHOẢN CHUỖI. Tạo tài khoản chuỗi → tải + duyệt giấy phép ở tài khoản đó →
 * thêm trạm có sẵn vào chuỗi (trạm nhận bên ký của chuỗi, hồ sơ riêng chuyển vào lịch sử).
 */
const o: React.CSSProperties = {
	padding: "6px 8px",
	border: "1px solid #d0d5dd",
	borderRadius: 6,
	fontSize: 14,
	minWidth: 0,
};
const nut = (chinh = false): React.CSSProperties => ({
	padding: "6px 12px",
	borderRadius: 6,
	border: chinh ? "1px solid #1565c0" : "1px solid #d0d5dd",
	background: chinh ? "#1565c0" : "#fff",
	color: chinh ? "#fff" : "#344054",
	cursor: "pointer",
	fontSize: 13,
	whiteSpace: "nowrap",
});
const loiCua = (e: any) => e?.response?.data?.message || e?.message || "Could not save. Please try again.";

export function TaoChuoiMoi(props: { onDone?: (msg: string) => void }) {
	const [mo, setMo] = useState(false);
	const [email, setEmail] = useState("");
	const [ten, setTen] = useState("");
	const [moi, setMoi] = useState(true);
	const [busy, setBusy] = useState(false);
	const [tb, setTb] = useState("");
	const gui = async () => {
		setBusy(true);
		setTb("");
		try {
			const { data } = await http.post("/admin/chains", {
				email: email.trim(),
				chainName: ten.trim(),
				sendInvite: moi,
			});
			const d = data?.data || {};
			setMo(false);
			props.onDone?.(
				`Chain #${d.storeId} “${d.chainName}” created — chain account #${d.ownerPartnerId}. ${
					d.emailSent ? "Login email sent." : "No email sent."
				} Next: open #${
					d.ownerPartnerId
				} › Business licence to upload and approve the licence, then add locations.`
			);
		} catch (e) {
			setTb(loiCua(e));
		} finally {
			setBusy(false);
		}
	};
	if (!mo)
		return (
			<button
				type="button"
				data-testid="create-chain"
				onClick={() => setMo(true)}
				style={{ ...nut(true), marginBottom: 10 }}>
				+ Create chain account
			</button>
		);
	return (
		<div
			style={{
				display: "grid",
				gap: 6,
				maxWidth: 420,
				padding: 10,
				border: "1px dashed #98a2b3",
				borderRadius: 8,
				marginBottom: 10,
			}}>
			<strong>Create chain account</strong>
			<span style={{ color: "#667085", fontSize: 13 }}>
				A login of its own (not a station). The business licence is attached to this account.
			</span>
			<input
				placeholder="Chain name (e.g. Kim Thanh Dat)"
				value={ten}
				onChange={(e) => setTen(e.target.value)}
				style={o}
			/>
			<input
				type="email"
				placeholder="Chain owner email — not used by any station"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				style={o}
			/>
			<label style={{ fontSize: 13 }}>
				<input
					type="checkbox"
					checked={moi}
					onChange={(e) => setMoi(e.target.checked)}
				/>{" "}
				Send login email to the chain owner
			</label>
			<span style={{ display: "flex", gap: 6 }}>
				<button
					type="button"
					disabled={busy}
					onClick={gui}
					style={nut(true)}>
					{busy ? "Creating…" : "Create"}
				</button>
				<button
					type="button"
					onClick={() => setMo(false)}
					style={nut()}>
					Cancel
				</button>
			</span>
			{tb ? <span style={{ color: "#b42318", fontSize: 13 }}>{tb}</span> : null}
		</div>
	);
}

type GoiYTram = { id: number; name: string; email: string | null; city: string | null; country: string | null };

export function ThemDiemVaoChuoi(props: { storeId: number; onDone?: (msg: string) => void }) {
	const [mo, setMo] = useState(false);
	const [id, setId] = useState("");
	// 02/11/2026 (Quân): tìm theo tên / số / email thay vì bắt gõ số ID. Gợi ý chỉ gồm trạm chưa thuộc chuỗi nào.
	const [tim, setTim] = useState("");
	const [goiY, setGoiY] = useState<GoiYTram[]>([]);
	const [daChon, setDaChon] = useState<GoiYTram | null>(null);
	const [daTim, setDaTim] = useState("");
	useEffect(() => {
		const q = tim.trim();
		if (!mo || daChon || !q) {
			setGoiY([]);
			return;
		}
		let huy = false;
		const t = setTimeout(async () => {
			try {
				const { data } = await http.get(`/admin/chains/${props.storeId}/add-location/candidates`, { params: { q } });
				if (!huy) setGoiY(Array.isArray(data?.data) ? data.data : []);
			} catch {
				if (!huy) setGoiY([]);
			}
			if (!huy) setDaTim(q);
		}, 250);
		return () => {
			huy = true;
			clearTimeout(t);
		};
	}, [tim, mo, daChon, props.storeId]);
	const go = (v: string) => {
		setTim(v);
		setDaChon(null);
		const so = v.trim().replace(/^#/, "");
		setId(/^\d+$/.test(so) ? so : "");
	};
	const chon = (g: GoiYTram) => {
		setDaChon(g);
		setId(String(g.id));
		setTim(`#${g.id} ${g.name}`);
		setGoiY([]);
	};
	const nhanGoiY = (g: GoiYTram) => [g.email, [g.city, g.country].filter(Boolean).join(", ")].filter(Boolean).join(" · ");
	const [lyDo, setLyDo] = useState("");
	const [busy, setBusy] = useState(false);
	const [tb, setTb] = useState("");
	const gui = async () => {
		setBusy(true);
		setTb("");
		try {
			const { data } = await http.post(`/admin/chains/${props.storeId}/add-location`, {
				partnerId: Number(id),
				reason: lyDo.trim(),
			});
			const d = data?.data || {};
			setMo(false);
			setId("");
			setTim("");
			setDaChon(null);
			setLyDo("");
			props.onDone?.(`Station #${d.partnerId} added to chain #${d.storeId} (signing party #${d.legalEntityId}).`);
		} catch (e) {
			setTb(loiCua(e));
		} finally {
			setBusy(false);
		}
	};
	if (!mo)
		return (
			<div>
				<button
					type="button"
					data-testid={`add-location-${props.storeId}`}
					onClick={() => setMo(true)}
					style={{ ...nut(), marginTop: 4 }}>
					+ Add station
				</button>
			</div>
		);
	return (
		<div style={{ display: "grid", gap: 6, marginTop: 6, maxWidth: 320 }}>
			<div style={{ position: "relative" }}>
				<input
					data-testid={`add-location-search-${props.storeId}`}
					placeholder="Search station by name, ID or email"
					value={tim}
					onChange={(e) => go(e.target.value)}
					style={{ ...o, width: "100%", boxSizing: "border-box" }}
				/>
				{goiY.length ? (
					<div
						role="listbox"
						style={{ position: "absolute", zIndex: 5, top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #d0d5dd", borderRadius: 6, marginTop: 2, maxHeight: 260, overflowY: "auto", boxShadow: "0 4px 12px rgba(16,24,40,.12)" }}>
						{goiY.map((g) => (
							<button
								key={g.id}
								type="button"
								role="option"
								data-testid={`add-location-option-${g.id}`}
								onClick={() => chon(g)}
								style={{ display: "block", width: "100%", textAlign: "left", padding: "6px 8px", border: "none", borderBottom: "1px solid #f2f4f7", background: "#fff", cursor: "pointer" }}>
								<div style={{ fontSize: 13, color: "#101828" }}>
									#{g.id} {g.name}
								</div>
								{nhanGoiY(g) ? <div style={{ fontSize: 12, color: "#667085" }}>{nhanGoiY(g)}</div> : null}
							</button>
						))}
					</div>
				) : tim.trim() && !daChon && daTim === tim.trim() ? (
					<div style={{ fontSize: 12, color: "#667085", marginTop: 2 }}>No matching station outside a chain.</div>
				) : null}
			</div>
			<input
				placeholder="Reason"
				value={lyDo}
				onChange={(e) => setLyDo(e.target.value)}
				style={o}
			/>
			<span style={{ display: "flex", gap: 6 }}>
				<button
					type="button"
					disabled={busy || !id}
					onClick={gui}
					style={nut(true)}>
					{busy ? "Adding…" : "Add"}
				</button>
				<button
					type="button"
					onClick={() => setMo(false)}
					style={nut()}>
					Cancel
				</button>
			</span>
			{tb ? <span style={{ color: "#b42318", fontSize: 12 }}>{tb}</span> : null}
		</div>
	);
}
